module.exports = __webpack_public_path__ + "static/img/icon_photo.eb5a80c9.svg";